import {Component, NgModule, enableProdMode, OnInit, ViewChild,  Input, EventEmitter, Output } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, ActivatedRoute ,NavigationExtras } from '@angular/router';
import { DxPopupModule, DxButtonModule, DxTemplateModule, DxDataGridComponent } from 'devextreme-angular';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import ArrayStore from 'devextreme/data/array_store'; 
import { StudEventNotificationService, StudentEventDetails}from './../../services/studeventnotification.service';
import { Configuration } from '../../../app.constants';
import {formatDate} from '@angular/common';
import {HelperService} from '../../../shared/services/helper.service';
import { DxFormComponent } from 'devextreme-angular';
 

@Component({
  selector: 'studentnotificationdetail',
  templateUrl: './studentnotificationdetail.component.html',
  styleUrls: ['./studentnotificationdetail.component.scss']
})
export class StudentnotificationdetailComponent implements OnInit {
	@ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
	@ViewChild(DxFormComponent) myform: DxFormComponent;
	@Input() index: any; 

  value: any[] = [];
  urlDoc: string;
  popupVisible: boolean;
  popupTitle: string;
  errorMessage: string[] = new Array(); 
  documentId: string;
	academicInstance: any;
	StudentNotificationDetails:StudentEventDetails;
	formMode: string;
	data:any; 
	isdisable=true;
	isValid:boolean;
	dataSource: any;  
	obj: any;
	sub:any;
	showButton = false; 
	popupVisible1: boolean; 
	isupload:boolean=false;   
  LanguageLabel:any;  
  CourseID:any;
  BranchID:any;
  CoursePartID:any;
  DivisionID:any;
  StudentNotificationDetailsData:any;
  DataList:any;
  StudentNotificationDetailsList:any;
  constructor(private router: Router,
		private route: ActivatedRoute, private helperService:HelperService,
		private StudEventNotificationService: StudEventNotificationService,private Configuration: Configuration) { 
			 
  }
  
	cancelClick() {
		this.router.navigate(['/dashboard']);
	}
  ngOnInit() {
    this.LanguageLabel =this.Configuration.LanguageLabel[0];
    this.StudentNotificationDetailsData=[]; 
    this.StudEventNotificationService.GetPersonalInformation(this.Configuration.StudentID)
      .subscribe((data:StudentEventDetails[]) => this.StudentNotificationDetailsData = data,
      error => {
      alert(error);
      },
      () => {debugger 
        this.StudentNotificationDetailsData= this.StudentNotificationDetailsData[0]; 
        
        this.StudEventNotificationService.GetStudentDetailsByStudentIDForNotification(this.Configuration.StudentID,this.Configuration.CollegeID, this.Configuration.ExamInstanceID)
        .subscribe((data:StudentEventDetails[]) => this.DataList = data,
        error => {
        alert(error);
        },
        () => {debugger 
          //this.DataList= this.DataList[0]; 
          if(this.DataList.length>0){  
            debugger
            this.CourseID=this.DataList[0].CourseID;
            this.BranchID=this.DataList[0].BranchID;
            this.CoursePartID=this.DataList[0].CoursePartID;
            this.DivisionID=this.DataList[0].DivisionID;

                this.StudEventNotificationService.GetNotificationDetailsListByStudentId(this.Configuration.StudentID,  this.Configuration.AcademicInstanceID,this.CourseID, this.BranchID, this.CoursePartID, this.DivisionID, this.Configuration.CollegeID)
                .subscribe((data:StudentEventDetails[]) => this.StudentNotificationDetailsList = data,
                error => {
                alert(error);
                },
                () => {debugger 
                  console.log(this.StudentNotificationDetailsList);   
                }); 
          }
        }); 

      });  
  }

  
  viewPdfDocument(data) {
    debugger
    if (data.data.ImagePath.length > 0) {
      this.documentId = data.data.EventID;
      this.urlDoc = data.data.ImagePath ;
      this.openWindow();
    }
  }
  
  openWindow() {
    this.popupTitle = this.LanguageLabel.View;
    this.errorMessage = [];
    this.showInfo();
  }
  showInfo() {
    this.popupVisible = true;
  }
  popupHiding(e) {
    this.errorMessage = [];
  };

}
